export default __webpack_public_path__ + "static/media/3.f1901154.jpg";